














import { Component, Vue, Prop } from 'vue-property-decorator'
import { IWebofficeCreateForm } from '@/apps/open/types/weboffice'
import { ElForm } from 'element-ui/types/form'

@Component({
  componentName: 'EditAppDialogBody'
})
export default class EditAppDialogBody extends Vue {
  @Prop()
  data?: IWebofficeCreateForm

  @Prop()
  submit!: Function

  $refs!: {
    form: ElForm
  }

  form: IWebofficeCreateForm = {
    app_id: '',
    app_name: '',
    website: '',
    description: '',
    ...this.data
  }

  rules = {
    app_name: [
      { required: true, message: '请填写应用名', trigger: ['blur', 'change'] }
    ],
    website: [
      { required: true, message: '请填写应用官网地址', trigger: ['blur', 'change'] },
      { type: 'url', message: '请填写正确的应用官网地址' }
    ],
    description: [
      { required: true, message: '请填写用途', trigger: ['blur', 'change'] }
    ]
  }

  onOk () {
    this.$refs.form.validate((valid: boolean) => {
      if (valid) this.submit(this.form)
    })
  }

  mounted () {
    this.$on('onOk', this.onOk)
  }
}
